import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-slate-950 text-slate-300 pt-16 pb-12 border-t border-slate-900 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          
          <div className="lg:col-span-2 space-y-4">
            {/* Footer Logo Image Placeholder */}
            <img 
              src="/Logo.png" 
              alt="AssuranceTech Innovation Logo" 
              className="h-20 w-auto object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="h-10 w-10 bg-blue-600 rounded-xl hidden items-center justify-center text-white font-black text-xl">
              A
            </div>

            <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
              Empowering minds, enriching lives, and transforming learning through intelligent technology, artificial intelligence, and faith-centered platforms.
            </p>

            <div className="pt-2">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">Stay Updated</p>
              {subscribed ? (
                <div className="bg-emerald-950/50 border border-emerald-500/30 text-emerald-400 text-xs p-3 rounded-xl font-medium">
                  ✓ Thank you for subscribing!
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="flex gap-2">
                  <input 
                    type="email" 
                    required
                    placeholder="Enter your email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-slate-900 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 flex-1"
                  />
                  <button type="submit" className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2.5 rounded-xl text-sm font-bold transition">
                    Join
                  </button>
                </form>
              )}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Ecosystem</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/quiz-learn-info" className="hover:text-blue-400 transition">Quiz & Learn</Link></li>
              <li><Link to="/nclexsmart-prep" className="hover:text-blue-400 transition">NCLEXSmart Prep</Link></li>
              <li><Link to="/pmhnp-smart-prep" className="hover:text-blue-400 transition">PMHNP Smart Prep</Link></li>
              <li><Link to="/cdip-smart-prep" className="hover:text-blue-400 transition">CDIP Smart Prep</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Faith & Family</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/kingdom-kids-daily-devotional" className="hover:text-blue-400 transition">Kingdom Kids</Link></li>
              <li><Link to="/riseup-365" className="hover:text-blue-400 transition">RiseUp 365</Link></li>
              <li><Link to="/daily-grace-365" className="hover:text-blue-400 transition">Daily Grace 365</Link></li>
              <li><Link to="/about" className="hover:text-blue-400 transition">About Us</Link></li>
            </ul>
          </div>

          <div className="space-y-3">
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Contact Us</h4>
            <p className="text-sm text-slate-400">Need support or corporate inquiries?</p>
            <Link 
              to="/contact" 
              className="inline-block bg-blue-600 hover:bg-blue-500 text-white font-bold px-4 py-2.5 rounded-xl text-xs transition shadow-md"
            >
              Open Contact Form
            </Link>
          </div>

        </div>

        <div className="border-t border-slate-900 pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500">
          <p>© {new Date().getFullYear()} AssuranceTech Innovation. All rights reserved.</p>
          <p className="mt-2 sm:mt-0 font-medium text-slate-400">Designed with intelligence & purpose.</p>
        </div>
      </div>
    </footer>
  );
}